import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatSlider, MatSliderThumb } from '@angular/material/slider';
import { DecimalPipe } from '@angular/common';

@Component({
    selector: 'app-slider-range-input',
    templateUrl: './slider-range-input.component.html',
    styleUrls: ['./slider-range-input.component.scss'],
    standalone: true,
    imports: [
        MatSlider,
        MatSliderThumb,
        DecimalPipe,
    ],
})
export class SliderRangeInputComponent {
  @Input() min = 2500;
  @Input() max = 50000;
  @Input() step = 500;
  @Input() value: number = 20000;
  @Input() disabled = false;

  @Output() valueChange = new EventEmitter<number>();

  onValueChange(value: string) {
    this.value = Number(value);
    this.valueChange.emit(Number(value));
  }
  get clampedPercent(): number {
    const min = Number(this.min ?? 0);
    const max = Number(this.max ?? 100);
    const val = Number(this.value ?? min);
    if (max === min) {
      return 0;
    }
    const p = val/(max-min)*180;
    return p;
  }
}
